import { Chip } from "@mui/material";
import { ColDef } from "ag-grid-community";
import { get } from "lodash-es";
import moment from "moment";
import React, { useMemo } from "react";
import { dxtToLocalServerTime } from "../../../../../../services/TimeService";
import { LOG_TYPE_CODES } from "../../../data/LogTypeCodes";

export const useLogTableData = (timezone: "UTC" | "Server") => {
	const backgroundColor = (logTypeCode: string) => {
		return get(LOG_TYPE_CODES, `${logTypeCode[0]}.color`, "#BBBBBB");
	};

	const columnDefs = useMemo<ColDef[]>(
		() => [
			{
				field: "Timestamp",
				headerName: "Time",
				minWidth: 220,
				flex: 1,
				headerClass: "ag-header-cell-centered",
				valueFormatter: ({ value }: { value: string }) => {
					if (!value) return "";
					return timezone === "UTC"
						? moment(value).utc().format("YYYY-MM-DD HH:mm:ss z")
						: dxtToLocalServerTime(value, "yyyy-MM-dd HH:mm:ss z");
				},
			},
			{
				field: "Source",
				headerName: "Source",
				minWidth: 290,
				flex: 2,
				type: "string",
				cellStyle: {
					justifyContent: "flex-start",
				},
			},
			{
				field: "Message",
				headerName: "Message",
				minWidth: 150,
				flex: 5,
				type: "string",
				cellStyle: {
					justifyContent: "flex-start",
				},
			},
			{
				field: "LogTypeCode",
				headerName: "Type",
				minWidth: 50,
				maxWidth: 70,
				flex: 1,
				cellRenderer: (params: any) => {
					return (
						<Chip
							style={{
								backgroundColor: backgroundColor(params.value),
								color: "white",
							}}
							label={params.value}
							size={"small"}
						/>
						// <div
						// 	style={{
						// 		padding: "2px 6px",
						// 		borderRadius: 4,
						// 		display: "flex",
						// 		alignItems: "center",
						// 		justifyContent: "center",
						// 		color: "#fff",
						// 		fontWeight: "bold",
						// 		fontSize: "0.75rem",
						// 		backgroundColor: backgroundColor(params.value),
						// 	}}
						// >
						// 	{params.value}
						// </div>
					);
				},
			},
			{
				field: "User",
				headerName: "User",
				minWidth: 70,
				flex: 1,
				type: "string",
				valueFormatter: ({ value }: { value: string }) => value || " ",
				headerClass: "ag-header-cell-centered",
			},
		],
		[timezone],
	);

	return { columnDefs };
};
